import { ApplicationService, type ApplicationCommentResponse } from '@acme/api';
import { createEffect, createEvent, createStore, sample } from 'effector';

export const applicationCommentsOpened = createEvent<{ id: string }>();

export const loadApplicationCommentsFx = createEffect(
  async ({ id }: { id: string }) => {
    const res = await ApplicationService.getApiV1ApplicationComments({ id });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || 'Произошла ошибка при загрузке комментариев заявки'
      );
    }
    return res.data ?? [];
  }
);

export const $applicationComments = createStore<ApplicationCommentResponse[]>(
  []
).on(loadApplicationCommentsFx.doneData, (_, data) => data);

export const $applicationCommentsError = createStore<string | null>(null)
  .on(applicationCommentsOpened, () => null)
  .on(loadApplicationCommentsFx.failData, (_, err) =>
    err instanceof Error
      ? err.message
      : 'Произошла ошибка при загрузке комментариев заявки'
  );

export const $isApplicationCommentsLoading = loadApplicationCommentsFx.pending;

sample({
  clock: applicationCommentsOpened,
  filter: ({ id }) => id.trim().length > 0,
  target: loadApplicationCommentsFx,
});
